export const MARKETING = 'marketing';
export const SALES = 'sales';
export const SERVICE = 'service';
export const CMS = 'cms';
export const OPERATIONS = 'operations';
export const CRM = 'crm';
export const SUITE = 'suite';
export const BUNDLE = 'bundle';
export const COMMERCE = 'commerce';
export const AllRoutes = [MARKETING, SALES, SERVICE, CMS, OPERATIONS, CRM, SUITE, BUNDLE, COMMERCE];